import React from 'react'

import * as dayjs from 'dayjs'


export const EarthquakeFilterContext = React.createContext()


export const earthquakeFilterDefaultState = {
  period: {
    enabled: false,
    start: '',
    end: '',
    timezone: 'KST',
  },
  magnitude: {
    enabled: false,
    min: '',
    max: '',
  },
  depth: {
    enabled: false,
    min: '',    // unit: km
    max: '',    // unit: km
  },
  location: {
    enabled: false,
    type: '',   // 'boxRange' or 'circleRange'
    minLat: '',
    maxLat: '',
    minLon: '',
    maxLon: '',
    centralLat: '',
    centralLon: '',
    minRadius: '',    // unit: km
    maxRadius: '',    // unit: km
  },
}


export const earthquakeFilterReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FILTER_VALUE':
      const {category, key, value: rawValue} = action
      const value = (rawValue && rawValue.trim) ? rawValue.trim() : rawValue
      if (category && state[category]) {
        if (value !== state[category][key]) {
          return {...state, [category]: {...state[category], [key]: value}}
        }
      }
      return state
    default:
      return state
  }
}


// // 일단 KQuake에서 기본적인 사용자의 input은 KST라고 인식하자.
// // 특히, 시간이 없는 날짜는 무조건 KST로 인식하는 것이 맞는것 같다.
// class ValidationError extends Error {}
// class InvalidTimezoneError extends Error {}
// const parseDateTimeString = (dateTimeStr, timezone) => {
//   let dateTimeUtc = dayjs.utc(dateTimeStr)
//   if (!dateTimeUtc.isValid()) {
//     throw new ValidationError()
//   }

//   if (timezone && timezone.toUpperCase() !== 'UTC') {
//     const capitalizedTimezone = timezone.toUpperCase()
//     if (capitalizedTimezone === 'KST') {
//       dateTimeUtc = dateTimeUtc.subtract(9, 'hour')
//     } else {
//       throw new InvalidTimezoneError(`Invalid or not supported timezone: ${timezone}`)
//     }
//   }
//   return dateTimeUtc.toDate()
// }

const DATE_USER_INPUT_FORMAT = 'YYYY-MM-DD'
const DATE_API_QUERY_FORMAT = 'YYYY-MM-DD'
// const DATETIME_API_QUERY_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS'
export const getKQuakeEarthquakeApiFilter = (state) => {
  const {period, magnitude, depth, location} = state
  const apiFilter = {}

  // Period
  if (period && period.enabled) {
    let startDate, endDate
    if (period.start) {
      startDate = dayjs(period.start, DATE_USER_INPUT_FORMAT)
      if (startDate.isValid()) {
        // apiFilter.start = startDate.subtract(9, 'hour').format(DATETIME_API_QUERY_FORMAT)
        apiFilter.start = startDate.format(DATE_API_QUERY_FORMAT)
      } else {
        throw new Error('invalidStartDateError')
      }
    }
    if (period.end) {
      endDate = dayjs(period.end, DATE_USER_INPUT_FORMAT)
      if (endDate.isValid()) {
        apiFilter.end = endDate.format(DATE_API_QUERY_FORMAT)
      } else {
        throw new Error('invalidEndDateError')
      }
    }
    if (apiFilter.start || apiFilter.end) {
      apiFilter.timezone = period.timezone
      if (apiFilter.start && apiFilter.end && (startDate > endDate)) {
        throw new Error('startDateLaterThanEndDateError')
      }
    }
  }

  // Magnitude
  if (magnitude && magnitude.enabled) {
    if (magnitude.min) {
      const minMag = parseFloat(magnitude.min)
      if (Number.isNaN(minMag)) {
        throw new Error('invalidMinMagnitudeError')
      }
      apiFilter.minmag = minMag
    }
    if (magnitude.max) {
      const maxMag = parseFloat(magnitude.max)
      if (Number.isNaN(maxMag)) {
        throw new Error('invalidMaxMagnitudeError')
      }
      apiFilter.maxmag = maxMag
    }
  }

  // Depth
  if (depth && depth.enabled) {
    if (depth.min) {
      const minDepth = parseFloat(depth.min)
      if (Number.isNaN(minDepth)) {
        throw new Error('invalidMinDepthError')
      }
      apiFilter.mindepth = minDepth
    }
    if (depth.max) {
      const maxDepth = parseFloat(depth.max)
      if (Number.isNaN(maxDepth)) {
        throw new Error('invalidMaxDepthError')
      }
      apiFilter.maxdepth = maxDepth
    }
  }

  // Location
  if (location && location.enabled) {
    if (location.type === 'boxRange') {
      const elements = [
        {key: 'minLat', apiKey: 'minlat', errorCodeAlias: 'MinLat'}, 
        {key: 'maxLat', apiKey: 'maxlat', errorCodeAlias: 'MaxLat'}, 
        {key: 'minLon', apiKey: 'minlon', errorCodeAlias: 'MinLon'}, 
        {key: 'maxLon', apiKey: 'maxlon', errorCodeAlias: 'MaxLon'}, 
      ]
      elements.forEach(({key, apiKey, errorCodeAlias}) => {
        if (location[key]) {
          const parsedValue = parseFloat(location[key])
          if (Number.isNaN(parsedValue)) {
            throw new Error(`invalid${errorCodeAlias}Error`)
          }
          apiFilter[apiKey] = parsedValue
        }
      })
    } else if (location.type === 'circleRange') {
      const elements = [
        {key: 'centralLat', apiKey: 'lat', errorCodeAlias: 'CentralLat'}, 
        {key: 'centralLon', apiKey: 'lon', errorCodeAlias: 'CentralLon'}, 
        {key: 'maxRadius', apiKey: 'maxradius_km', errorCodeAlias: 'MaxRadius'}, 
      ]
      elements.forEach(({key, apiKey, errorCodeAlias}) => {
        if (location[key]) {
          const parsedValue = parseFloat(location[key])
          if (Number.isNaN(parsedValue)) {
            throw new Error(`invalid${errorCodeAlias}Error`)
          }
          apiFilter[apiKey] = parsedValue
        } else {
          throw new Error(`no${errorCodeAlias}Error`)
        }
      })
    }
  }

  return apiFilter
}
